@let cardModeEnabled = cardMode();
@let flexModeEnabled = flexMode();

<div
  class="table-responsive"
  [class.-selected-rows]="selectable"
  [class.h-100]="flexModeEnabled"
  [mbsTableSortGroup]="changeSortState"
  [style.min-height]="minHeight"
  (sort)="handleSort($event)">
  @if (!loading || $any(dataSource)?.data || (data || []).length) {
    <ng-container [ngTemplateOutlet]="secondLoader" />

    @if (parentScrollMode === 'infinite') {
      <div
        #table
        infiniteScroll
        role="table"
        [infiniteScrollDistance]="infiniteScrollDistance"
        [infiniteScrollThrottle]="infiniteScrollThrottle"
        [mbsTableSortGroup]="changeSortState"
        [ngClass]="classTableGridObject"
        [rotateSequence]="rotateSequence"
        [scrollWindow]="scrollWindow"
        [style.max-height]="maxHeight"
        (scrolled)="scrolled.emit()">
        <ng-container [ngTemplateOutlet]="content" />
      </div>
    } @else {
      @if (cardModeEnabled) {
        <div
          #table
          class="cardModeEnabled"
          mbsSizeObserver
          role="table"
          [mbsTableSortGroup]="changeSortState"
          [ngClass]="classTableGridObject"
          [rotateSequence]="rotateSequence"
          [style.max-height]="maxHeight"
          [style.min-height]="minHeight"
          (scroll)="onTableScroll($event)"
          (sizeChanged)="handleGridSizeChanged($event)">
          <ng-container [ngTemplateOutlet]="content" />
        </div>
      } @else {
        @if (flexModeEnabled) {
          <div
            #table
            mbsSizeObserver
            role="table"
            [mbsTableSortGroup]="changeSortState"
            [ngClass]="classTableGridObject"
            [rotateSequence]="rotateSequence"
            [style.max-height]="maxHeight"
            [style.min-height]="minHeight"
            (scroll)="onTableScroll($event)"
            (sizeChanged)="handleGridSizeChanged($event)">
            <ng-container [ngTemplateOutlet]="content" />
          </div>
        } @else {
          <div
            #table
            role="table"
            [mbsTableSortGroup]="changeSortState"
            [ngClass]="classTableGridObject"
            [rotateSequence]="rotateSequence"
            [style.max-height]="maxHeight"
            [style.min-height]="minHeight"
            (scroll)="onTableScroll($event)">
            <ng-container [ngTemplateOutlet]="content" />
          </div>
        }
      }
    }
  } @else {
    <div class="mbs-loader-container">
      <mbs-loader />
    </div>
  }

  <ng-template #secondLoader>
    @if (loading) {
      <div class="mbs-loader">
        <mbs-loader
          [hasVerticalScroll]="gridSize()?.hasVerticalScroll"
          [useFixedDocumentSpinner]="useFixedDocumentSpinner"
          [useFixedSize]="!!maxHeight" />
      </div>
    }
  </ng-template>

  <ng-template
    #textHeader
    let-column>
    @if (column.sort; as sort) {
      <div
        class="mbs-table-grid_cell -sortable"
        role="cell"
        [ngClass]="headerClassToObject(column)"
        [sortable]="sort">
        <div class="form-row overflow-hidden">
          <div class="col overflow-hidden">
            @if (column.name; as name) {
              <mbs-text-ellipsis
                [placement]="'top-left auto'"
                [tooltip]="name"
                [tooltipClass]="'tooltip-lg'">
                {{ name }}
              </mbs-text-ellipsis>
            }
          </div>

          <div class="col-auto px-0">
            <span sortArrow></span>
          </div>

          <ng-container [ngTemplateOutlet]="info" />
        </div>
      </div>
    } @else {
      <div
        class="mbs-table-grid_cell"
        role="cell"
        [ngClass]="headerClassToObject(column)">
        {{ column.name }}

        <ng-container [ngTemplateOutlet]="info" />
      </div>
    }

    <ng-template #info>
      @if (column.info; as info) {
        <span
          class="fa fa-info-circle text-info ml-2 mr-1 table-header-info-tooltip"
          [container]="'body'"
          [ngbTooltip]="info"
          [placement]="'top'"
          [tooltipClass]="column.infoClass || 'text-start'"></span>
      }
    </ng-template>
  </ng-template>

  <ng-template #content>
    <ng-template #contentHeader>
      <div
        #contentHeaderBox
        [class.-scrollable]="scrollable"
        [class.-sticky-column-with-vr]="stickyColumnWithVR"
        [class.cardHeader]="cardModeEnabled"
        [class.mbs-table-grid-sticky-header]="stickyHeader || flexModeEnabled"
        [class.position-relative]="!maxHeight && !stickyHeader && !flexModeEnabled"
        [class.position-sticky.sticky-top]="maxHeight && !stickyHeader"
        [class.pr-3]="flexModeWithVerticalScroll() && !cardModeEnabled">
        @if (loading) {
          <div
            class="mbs-loader-bg"
            [ngClass]="bgLoaderClass"></div>
        }

        @if (showHeaders) {
          <div
            class="mbs-table-grid_header mbs-table-grid_row"
            role="row"
            [class.row-card]="cardModeEnabled"
            [style.grid-template-columns]="rowStyles.gridHeaderColumns"
            [style.padding-left]="!collapsibleMode && bindChildren && showCheckboxes ? checkboxCellWidth : ''">
            @if (showCheckboxes && (!bindChildren || collapsibleMode)) {
              <div class="mbs-table-grid_cell mbs-table-grid_checkbox-cell">
                @if (multipleSelect && showSelectAllCheckbox) {
                  <mbs-checkbox
                    [disabled]="isDisableHeaderCheckbox"
                    [indeterminate]="indeterminateMainCheckbox"
                    [size]="size"
                    [(ngModel)]="allChecked" />
                }
              </div>
            }

            @if (collapsibleMode && !needToggleOnEndRow) {
              <div class="mbs-table-grid_cell"></div>
            }

            @for (column of headers; track column?.name || $index) {
              @if (findHeaderTemplate(column); as template) {
                <div
                  class="mbs-table-grid_cell"
                  role="cell"
                  [ngClass]="headerClassToObject(column)">
                  <ng-container
                    [ngTemplateOutlet]="template"
                    [ngTemplateOutletContext]="{ $implicit: column }" />
                </div>
              } @else {
                <ng-container
                  [ngTemplateOutlet]="textHeader"
                  [ngTemplateOutletContext]="{ $implicit: column }" />
              }
            }
          </div>
        }

        <ng-container [ngTemplateOutlet]="selectAllTemplate" />

        @if (underHeaderTemplate) {
          <ng-container [ngTemplateOutlet]="underHeaderTemplate" />
        }
      </div>
    </ng-template>

    @if (parentScrollMode !== 'virtual') {
      <ng-container [ngTemplateOutlet]="contentHeader" />
    }

    <div
      [class.content-flex-mode]="flexModeEnabled"
      [class.mbs-loader-container]="loading"
      [class.pr-3]="flexModeWithVerticalScroll() && !cardModeEnabled">
      <div
        class="mbs-table-grid_content"
        [ngClass]="contentClassObject()">
        @if (loading) {
          <div
            class="mbs-loader-bg"
            [ngClass]="bgLoaderClass"></div>
        }
        @if (parentScrollMode === 'virtual') {
          <ng-container [ngTemplateOutlet]="contentHeader" />
        }

        @if (parentScrollMode === 'virtual') {
          <div
            class="table-virtual-scroll"
            [style.height]="virtualScrollViewportSize">
            <cdk-virtual-scroll-viewport
              #viewport
              scrollViewport
              [itemSize]="virtualScrollItemSize"
              [maxBufferPx]="maxBufferPx"
              [minBufferPx]="minBufferPx"
              (scroll)="cvrScrollHandler($any($event))"
              (scrolledIndexChange)="scrolledIndexChange.emit($event)"
              (scrollend)="scrollEnd.emit($event)">
              <ng-container
                *cdkVirtualFor="
                  let row of dataSource ? dataSource : data || [];
                  templateCacheSize: virtualTemplateCacheSize || 0;
                  let rowIndex = index;
                  trackBy: myTrackBy
                ">
                <ng-container
                  [ngTemplateOutlet]="tableRow"
                  [ngTemplateOutletContext]="{ row, rowIndex, data }" />
              </ng-container>

              <ng-container [ngTemplateOutlet]="noDataTemplate" />
            </cdk-virtual-scroll-viewport>
          </div>
        } @else {
          @for (row of data || []; track myTrackBy?.(row) ?? row; let rowIndex = $index) {
            <ng-container
              [ngTemplateOutlet]="tableRow"
              [ngTemplateOutletContext]="{ row, rowIndex, data }" />
          }

          <ng-container [ngTemplateOutlet]="noDataTemplate" />
        }
      </div>
    </div>
  </ng-template>
</div>

@if (infiniteScrollLoading) {
  <div class="mt-2 d-flex justify-content-center">
    <span class="loader loader-dark"></span>
  </div>
}

<ng-template #noDataTemplate>
  @if (!hasData() && !loading) {
    <div
      class="mbs-table-grid_row d-flex align-items-center no-data"
      role="row">
      <ng-container [ngTemplateOutlet]="$any(noDataIsTemplate() ? noDataMessage : noDataDefault)" />
    </div>
  }
</ng-template>

<ng-template #selectAllTemplate>
  @if (showSelectAllHint && totalItems && (bindChildren || dataSource ? flatData?.length : data?.length) === selectedItems?.length) {
    <div class="mbs-table-grid_row mbs-table-grid_hint bg-white">
      <div
        class="mbs-table-grid_cell -center d-flex mbs-table-grid_cell-total"
        role="cell">
        @if (selectedCountText && isTemplate(selectedCountText)) {
          <ng-container [ngTemplateOutlet]="$any(selectedCountText)" />
        } @else {
          {{ selectedCountText || getSelectedCountTextDefault() }}
        }

        @if (isSelectedAllOnAllPages()) {
          <mbs-button
            class="ml-1"
            [customClasses]="'fw-semibold'"
            [isCtrl]="true"
            (click)="clearSelection()">
            {{ cancelSelectionText || cancelSelectionTextDefault }}
          </mbs-button>
        } @else {
          <mbs-button
            class="ml-1"
            [customClasses]="'fw-semibold'"
            [isCtrl]="true"
            (click)="selectAllOnAllPagesHandle()">
            {{ selectAllButtonText || getSelectAllButtonTextDefault() }}
          </mbs-button>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #noDataDefault>
  <div
    class="mbs-table-grid_cell flex-grow-1 text-center"
    role="cell">
    {{ noDataMessage || noDataMessageDefault }}
  </div>
</ng-template>

<ng-template
  #tableRow
  let-data="data"
  let-row="row"
  let-rowIndex="rowIndex">
  @if (isCardHeader(row?.item || row)) {
    <div
      class="mbs-table-grid_row row-card mbs-table-grid_hint mt-3"
      role="row"
      [ngClass]="getClassListForRow(row.item, true, rowIndex)">
      @if (myTemplates[0]; as template) {
        <div
          class="mbs-table-grid_cell cell-card -center d-flex mbs-table-grid_cell-total"
          role="cell"
          [ngClass]="columnClassToObject(headers, 0)"
          [style.max-width]="getGridWidth()">
          <ng-container
            [ngTemplateOutlet]="template"
            [ngTemplateOutletContext]="{ $implicit: row.item, row, rowIndex, data }" />
        </div>
      }
    </div>
  }

  @if ((bindChildren || collapsibleMode) && !isCardHeader(row?.item || row)) {
    <div
      class="mbs-table-grid_row"
      role="row"
      [container]="tooltipForDisabledRow?.container || 'body'"
      [disableTooltip]="!tooltipForDisabledRow || !disabledStateByRow(row?.item)"
      [ngbTooltip]="row.item?.disabledRowTooltipText || tooltipForDisabledRow?.text || ''"
      [ngClass]="getClassListForRow(row.item, true, rowIndex)"
      [placement]="tooltipForDisabledRow?.placement || 'top-left'"
      [style.grid-template-columns]="collapsibleMode ? rowStyles?.gridTemplateColumns : subtitleStyles?.gridTemplateColumns"
      (click)="handleRowClick(row, true, $event)">
      @if (showCheckboxes) {
        <div
          class="mbs-table-grid_cell mbs-table-grid_checkbox-cell"
          [ngClass]="checkboxCellClass">
          <!-- parent checkbox -->
          <div
            class="mbs-table-grid_checkbox"
            [class.-checked]="isChecked(row, true)"
            [class.-disabled]="disabledStateByRow(row.item)"
            [class.-indeterminate]="!collapsibleMode ? indeterminateState(row) : row.indeterminate"
            [ngClass]="size ? '-' + size : ''"></div>
        </div>
      }

      @if (collapsibleMode && !needToggleOnEndRow) {
        <div
          class="mbs-table-grid_cell mbs-table-grid_cell-toggler"
          role="cell"
          [class.align-items-center]="lazy && row.loadingChildren"
          [class.d-flex]="lazy && row.loadingChildren"
          [class.justify-content-center]="lazy && row.loadingChildren">
          @if (
            (!lazy && bindChildren && row.item[bindChildren] && row.item[bindChildren].length > 0) ||
            (lazy && !row.loadingChildren && !row.loadedChildren) ||
            (lazy && row.loadedChildren && row.item[bindChildren] && row.item[bindChildren].length > 0)
          ) {
            <button
              class="ctrl ctrl-dark mbs-table-grid_toggler"
              [class.collapsed]="isCollapsed(row.item)"
              (click)="handleToggleCollapse($event, row)"></button>
          }

          @if (lazy && row.loadingChildren) {
            <span class="loader loader-dark"></span>
          }
        </div>
      }

      @for (template of myTemplates; track template) {
        <div
          class="mbs-table-grid_cell"
          role="cell"
          [ngClass]="columnClassToObject(collapsibleMode ? headers : subtitleHeaders, $index)">
          <ng-container
            [ngTemplateOutlet]="template"
            [ngTemplateOutletContext]="{ $implicit: row.item, row, rowIndex }" />
        </div>
      }

      @if (collapsibleMode && needToggleOnEndRow) {
        <div
          class="mbs-table-grid_cell mbs-table-grid_cell-toggler"
          role="cell"
          [class.align-items-center]="lazy && row.loadingChildren"
          [class.d-flex]="lazy && row.loadingChildren"
          [class.justify-content-center]="lazy && row.loadingChildren">
          @if (
            (!lazy && bindChildren && row.item[bindChildren] && row.item[bindChildren].length > 0) ||
            (lazy && !row.loadingChildren && !row.loadedChildren) ||
            (lazy && row.loadedChildren && row.item[bindChildren] && row.item[bindChildren].length > 0)
          ) {
            <button
              class="ctrl ctrl-dark mbs-table-grid_toggler"
              [class.collapsed]="isCollapsed(row.item)"
              (click)="handleToggleCollapse($event, row)"></button>
          }

          @if (lazy && row.loadingChildren) {
            <span class="loader loader-dark"></span>
          }
        </div>
      }
    </div>

    @if (bindChildren && row.item[bindChildren] && row.item[bindChildren].length > 0 && (collapsibleMode ? !isCollapsed(row.item) : true)) {
      <div
        class="mbs-table-grid_table-inner"
        [class.-collapsible]="collapsibleMode"
        [class.-scrollable]="collapsibleMode && virtualScrolling">
        @if (collapsibleMode && showChildrenHeaders) {
          <div
            class="mbs-table-grid_header mbs-table-grid_row"
            role="row"
            [ngClass]="childHeaderClasses"
            [style.grid-template-columns]="subtitleStyles?.gridTemplateColumns"
            [style.padding-left]="collapsibleMode && !needToggleOnEndRow ? checkboxCellWidth : ''">
            @if (showCheckboxes && showCheckboxesForChildren) {
              <div class="mbs-table-grid_cell"></div>
            }

            @for (column of subtitleHeaders; track column?.name || $index) {
              <ng-container
                [ngTemplateOutlet]="textHeader"
                [ngTemplateOutletContext]="{ $implicit: column }" />
            }
          </div>
        }

        @for (childRow of row.item[bindChildren] || []; track myTrackBy?.(childRow) ?? childRow; let rowIndex = $index) {
          <ng-template
            [ngTemplateOutlet]="tableRow"
            [ngTemplateOutletContext]="{ $implicit: childRow, rowIndex, data: row.item[bindChildren] }" />
        }

        <ng-template
          #tableRow
          let-childRow
          let-data="data"
          let-rowIndex="rowIndex">
          <div
            class="mbs-table-grid_row"
            role="row"
            [ngClass]="getClassListForRow(childRow, false, rowIndex)"
            [style.grid-template-columns]="collapsibleMode ? subtitleStyles?.gridTemplateColumns : rowStyles.gridTemplateColumns"
            [style.padding-left]="collapsibleMode && needChildrenPaddingLeft ? checkboxCellWidth : ''"
            (click)="handleRowClick(childRow, false, $event)">
            @if (showCheckboxes && showCheckboxesForChildren) {
              <div
                class="mbs-table-grid_cell mbs-table-grid_checkbox-cell"
                [ngClass]="checkboxCellClass">
                <!-- child checkbox -->
                <div
                  class="mbs-table-grid_checkbox"
                  [class.-checked]="isChecked(childRow, false)"
                  [class.-disabled]="disabledStateByRow(row.item)"
                  [ngClass]="size ? '-' + size : ''"></div>
              </div>
            }

            @for (template of myChildrenTemplates; track template) {
              <div
                class="mbs-table-grid_cell"
                role="cell"
                [ngClass]="columnClassToObject(collapsibleMode ? subtitleHeaders : actualTableColumnsForStyles, $index)">
                <ng-container
                  [ngTemplateOutlet]="template"
                  [ngTemplateOutletContext]="{
                    $implicit: childRow,
                    parent: row,
                    parentItem: row.item,
                    rowIndex
                  }" />
              </div>
            }
          </div>
        </ng-template>
      </div>
    }
  }

  @if (!bindChildren && !isCardHeader(row?.item || row)) {
    <div
      #rowContextMenuRef="contextMenuRef"
      #tooltip="ngbTooltip"
      class="mbs-table-grid_row"
      role="row"
      [container]="tooltipForDisabledRow?.container || 'body'"
      [contextMenuPlacement]="rowContextMenu?.placement"
      [disableTooltip]="!tooltipForDisabledRow || !disabledStateByRow(row?.item || row)"
      [mbsContextMenu]="rowContextMenu"
      [ngbTooltip]="row.item?.disabledRowTooltipText || tooltipForDisabledRow?.text || ''"
      [ngClass]="getClassListForRow(row.item || row, true, rowIndex)"
      [placement]="tooltipForDisabledRow?.placement || 'top-left'"
      [style.grid-template-columns]="rowStyles.gridTemplateColumns"
      (click)="handleRowClick(row, true, $event)"
      (closedContextMenu)="handleContextMenuClosedEvent()"
      (contextmenu)="handleContextMenu($event, rowContextMenuRef, row?.item || row)"
      (openedContextMenu)="handleContextMenuOpenedEvent(row?.item || row)">
      @if (showCheckboxes) {
        <div
          class="mbs-table-grid_cell mbs-table-grid_checkbox-cell"
          [ngClass]="checkboxCellClass">
          <!-- parent checkbox -->
          <div
            class="mbs-table-grid_checkbox"
            [class.-checked]="isChecked(row, true)"
            [class.-disabled]="disabledStateByRow(row.item || row)"
            [class.-indeterminate]="indeterminateState(row)"
            [ngClass]="size ? '-' + size : ''"></div>
        </div>
      }

      @for (template of myTemplates; track template) {
        <div
          class="mbs-table-grid_cell"
          role="cell"
          [class.-disabled]="disabledStateByRow(row.item || row)"
          [ngClass]="columnClassToObject(actualTableColumnsForStyles, $index)">
          <ng-container
            [ngTemplateOutlet]="template"
            [ngTemplateOutletContext]="{ $implicit: row.item || row, row, rowIndex }" />
        </div>
      }
    </div>
  }
</ng-template>
